/** the tags that are allowed to contain text */
export const TEXT_CONTAINING_TAG_LIST = [
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote',
  'li',
  'td',
  'th',
  'pre',
  'a',
  'strong',
  'em',
  'del',
  'code',
  'sup',
  'sub',
  'span',
  'b',
  'i',
] as const
